import type { FacetsData } from './facets-shared';

export interface FacetAutocompleteOption {
  attribute: string;
  value: string;
  label: string;
  count: number;
  attributeLabel: string;
  searchText: string;
}

// Keep only the top N results to avoid flooding the UI
const DEFAULT_FACET_SUGGESTION_LIMIT = 12;

export function buildFacetAutocompleteOptions(
  facetsData: FacetsData,
  attributeLabels: Record<string, string>
): FacetAutocompleteOption[] {
  if (!facetsData || typeof facetsData !== 'object') {
    return [];
  }

  const options: FacetAutocompleteOption[] = [];

  Object.entries(facetsData).forEach(([attribute, values]) => {
    if (!Array.isArray(values) || values.length === 0) {
      return;
    }

    const attributeLabel = attributeLabels[attribute] || attribute;

    values.forEach((value) => {
      if (!value || typeof value.value !== 'string') {
        return;
      }
      const label = value.label || value.value;
      const count = typeof value.count === 'number' ? value.count : 0;
      const searchText = `${attributeLabel} ${label} ${value.value}`.toLowerCase();

      options.push({
        attribute,
        value: value.value,
        label,
        count,
        attributeLabel,
        searchText,
      });
    });
  });

  return options;
}

export function filterFacetAutocompleteOptions(
  options: FacetAutocompleteOption[],
  query: string,
  limit: number = DEFAULT_FACET_SUGGESTION_LIMIT
): FacetAutocompleteOption[] {
  if (!options || options.length === 0) {
    return [];
  }

  const normalizedQuery = query.trim().toLowerCase();

  const filtered = normalizedQuery
    ? options.filter((option) => option.searchText.includes(normalizedQuery))
    : options;

  return filtered
    .sort((a, b) => {
      if (a.count === b.count) {
        return a.label.localeCompare(b.label);
      }
      return b.count - a.count;
    })
    .slice(0, limit);
}








